export default {
  getIsDisabledAddToCart(state) {
    return state.isDisabledAddToCart;
  },

  getIsAddToCartButton(_1, _2, _3, allGetters) {
    const isElementBasket = allGetters?.['models/getIsElementBasket'];
    const isNoHideBlocksBasket = allGetters?.['user/getIsNoHideBlocksBasket'];
    const isNoBasketEdit = allGetters?.['basket/getIsNoBasketEdit'];

    return isElementBasket && isNoHideBlocksBasket && isNoBasketEdit;
  },

  getIsOptionComment(_1, _2, _3, allGetters) {
    const isElementBasket = allGetters?.['models/getIsElementBasket'];
    const isNoHideBlocksBasket = allGetters?.['user/getIsNoHideBlocksBasket'];

    return isElementBasket && isNoHideBlocksBasket;
  },
};
